export const lastCheckTable = (data = []) => {
    return (
        data &&
        data.length &&
        data.map((item, index) => {
            const {
                id,
                url,
                status,
                response_time,
                http_status_code_client,
                campaigns_count,
                job_id,
                created_at,
            } = item;

            return {
                id,
                url,
                status,
                response_time: Math.floor(response_time*100) + ' ms',
                http_status_code_client,
                campaigns_count,
                job_id,
                created_at,
            };
        })
    );
};

export const lastCheckTableTitles = () => {
    return [
        {
            title: "IP",
            alias: "ip",
        },
        {
            title: "Account",
            alias: "account",
        },
        {
            title: "Campaign",
            alias: "campaign",
        },
        {
            title: "Clicked on",
            alias: "created_at",
        },
        {
            title: "Detected",
            alias: "detected",
        },
    ];
};
